<template>
  <v-container fluid class="pa-0">
    <!--TOOLBAR-->
    <div class="vehicle-entry-toolbar-root">
      <div
        class="bg-red-darken-3 vehicle-entry-toolbar-strip pt-2 pb-2 pb-md-3 px-3 px-md-6 px-lg-8"
      >
        <v-row
          align="center"
          class="vehicle-entry-toolbar-row flex-wrap"
          no-gutters
        >
          <v-col
            cols="auto"
            class="d-none d-md-flex align-center flex-shrink-0 vehicle-entry-toolbar-brand ga-3"
          >
            <div class="text-subtitle-1 text-white text-truncate">
              {{ $t("vehicle_entry.label") }}
            </div>
            <v-divider class="flex-shrink-0" inset vertical />
          </v-col>

          <v-col
            cols="12"
            md="auto"
            class="vehicle-entry-toolbar-actions flex-grow-1 min-width-0"
          >
            <div
              class="d-flex flex-wrap align-center ga-2 ga-md-3 w-100 justify-start justify-md-end"
            >
              <v-btn
                v-if="$store.getters.role == 'SuperAdmin'"
                class="vehicle-entry-toolbar-btn flex-shrink-0"
                :size="$vuetify.display.mdAndUp ? 'default' : 'small'"
                @click="openPopulate"
              >
                <v-icon start> mdi-plus </v-icon>
                populate
              </v-btn>
              <v-btn
                color="grey-darken-4"
                variant="flat"
                class="vehicle-entry-toolbar-btn flex-shrink-0"
                :size="$vuetify.display.mdAndUp ? 'default' : 'small'"
                @click="scanQr"
              >
                <v-icon start> mdi-qrcode </v-icon>
                {{ $t("parts.inventory.scan_qr") }}
              </v-btn>
              <v-btn
                color="grey-darken-4"
                variant="flat"
                class="vehicle-entry-toolbar-btn flex-shrink-0"
                :size="$vuetify.display.mdAndUp ? 'default' : 'small'"
                @click="openAddVehicleDialog"
              >
                <v-icon start> mdi-car </v-icon>
                {{ $t("vehicle_entry.add_car") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-tabs v-model="mode" fixed-tabs bg-color="red-darken-3" theme="dark">
      <v-tabs-slider color="grey-darken-4" />

      <v-tab :key="0">
        {{ $t("vehicle_entry.vehicles_inventory") }}
      </v-tab>
      <v-tab :key="1">
        {{ $t("vehicle_entry.vehicles_history") }}
      </v-tab>
    </v-tabs>

    <!----------------------------------------ADD VEHICLE------------------------------------------>
    <v-dialog v-model="addVehicleDialog" :fullscreen="$vuetify.display.smAndDown">
      <v-card>
        <v-card-title
          class="redColor add-vehicle-dialog-title d-flex text-white align-center"
        >
          <span class="headline flex-grow-1">
            {{ $t("vehicle_entry.add_car") }}
          </span>

          <v-spacer class="d-none d-md-flex" />
          <v-btn
            variant="outlined"
            icon
            color="white"
            class="add-vehicle-close-btn flex-shrink-0"
            size="small"
            @click="closeAddVehicleDialog"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <!--STEPPER-->
          <v-stepper v-model="stepper">
            <!-- Stepper Header -->
            <v-stepper-header>
              <v-stepper-item
                :value="1"
                :complete="stepper > 1"
                title="Car Details"
              />
              <v-divider />
              <v-stepper-item
                :value="2"
                :complete="stepper > 2"
                :title="$t('vehicle_entry.step_grafiche')"
              />
              <v-divider />
              <v-stepper-item :value="3" title="Car Files" />
            </v-stepper-header>

            <!-- Stepper Window (content area) -->
            <v-stepper-window>
              <!-- STEP 1 — CAR DETAILS -->
              <v-stepper-window-item :value="1">
                <select-vehicle
                  ref="selectVehicle"
                  class="pl-4 pr-4"
                  @selected="setSelectedVehicle"
                  @close-add-vehicle="closeAddVehicleDialog"
                />
                <vehicle-details
                  ref="vehicleDetails"
                  @car="selectVehicle"
                  @identifier-error="onIdentifierError"
                />

                <v-card-actions class="mt-3 d-flex flex-column align-end">
                  <div
                    v-if="identifierError"
                    class="text-caption text-error pb-1 px-2 text-end"
                  >
                    {{ identifierError }}
                  </div>
                  <div class="d-flex ga-2">
                    <v-btn
                      color="grey-darken-4"
                      variant="outlined"
                      @click="closeAddVehicleDialog"
                    >
                      {{ $t("vehicle_entry.cancel") }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      variant="outlined"
                      :disabled="!vehicle.details"
                      @click="continueFromDetails"
                    >
                      {{ $t("vehicle_entry.continue") }}
                      <v-icon end> mdi-chevron-right </v-icon>
                    </v-btn>
                  </div>
                </v-card-actions>
              </v-stepper-window-item>

              <!-- STEP 2 — Categories (default) | Vehicle CAD -->
              <v-stepper-window-item :value="2">
                <vehicle-details class="d-none" @car="selectVehicle" />

                <v-tabs
                  v-model="step2ViewTab"
                  color="red-darken-3"
                  slider-color="grey-darken-4"
                  bg-color="grey-lighten-4"
                  class="grafiche-step2-tabs"
                >
                  <v-tab value="grafiche">
                    {{ $t("vehicle_entry.step2_tab_grafiche") }}
                  </v-tab>
                  <v-tab value="cad">
                    {{ $t("vehicle_entry.step2_tab_cad") }}
                  </v-tab>
                </v-tabs>

                <div v-show="step2ViewTab === 'grafiche'">
                  <infocar-grafiche-accordion
                    ref="graficheAccordion"
                    :vehicle="vehicle"
                  />
                </div>
                <div v-show="step2ViewTab === 'cad'">
                  <v-row class="justify-center pa-4">
                    <v-col cols="12" class="d-flex justify-center">
                      <vehicle-view
                        ref="vehicleView"
                        @position="openPartSelectionDialog"
                      />
                    </v-col>
                  </v-row>
                </div>

                <v-card-actions class="mt-3">
                  <v-spacer />
                  <v-btn
                    color="grey-darken-4"
                    variant="outlined"
                    @click="stepper = 1"
                  >
                    <v-icon start> mdi-chevron-left </v-icon>
                    {{ $t("vehicle_entry.back") }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    variant="outlined"
                    @click="goStepThreeFromCategories"
                  >
                    {{ $t("vehicle_entry.continue") }}
                    <v-icon end> mdi-chevron-right </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-stepper-window-item>

              <!-- STEP 3 — CAR FILES -->
              <v-stepper-window-item :value="3" class="mt-5">
                <vehicle-details class="d-none" @car="selectVehicle" />
                <select-vehicle
                  ref="selectVehicle"
                  class="d-none"
                  @selected="setSelectedVehicle"
                />
                <!-- PHOTOS -->
                <v-divider />
                <v-row class="justify-center pa-4">
                  <div>{{ $t("vehicle_entry.photos") }}</div>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    variant="text"
                    small
                    @click="openPhotosDialog"
                  >
                    {{ $t("vehicle_entry.add_photos") }}
                    <v-icon end>mdi-plus</v-icon>
                  </v-btn>
                </v-row>
                <v-row>
                  <v-col
                    v-for="(data, index) in vehicle.photos"
                    :key="index"
                    xs="6"
                    sm="4"
                    md="3"
                    lg="3"
                    xl="3"
                    class="pa-1 d-flex mb-4"
                  >
                    <v-img :src="data.dataUrl" />
                  </v-col>
                </v-row>

                <!-- VIDEOS -->
                <v-divider />
                <v-row class="justify-center pa-4">
                  <div>{{ $t("vehicle_entry.videos") }}</div>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    variant="text"
                    small
                    @click="openVideosDialog"
                  >
                    {{ $t("vehicle_entry.add_video") }}
                    <v-icon end>mdi-plus</v-icon>
                  </v-btn>
                </v-row>
                <v-row v-if="vehicle.video">
                  <video
                    :src="vehicle.video.dataUrl"
                    :width="videoWidth"
                    controls
                  />
                </v-row>

                <!-- DOCUMENTS -->
                <v-divider />
                <v-row class="justify-center pa-4">
                  <div>{{ $t("vehicle_entry.upload_document") }}</div>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    variant="text"
                    small
                    @click="openPdfInputComponent"
                  >
                    {{ $t("vehicle_entry.upload_document") }}
                    <v-icon end>mdi-plus</v-icon>
                  </v-btn>
                </v-row>

                <v-btn v-if="vehicle.pdf" icon @click="viewPdf">
                  <v-icon color="grey-darken-4"
                    >mdi-file-document-outline</v-icon
                  >
                </v-btn>

                <input
                  ref="pdfInput"
                  type="file"
                  style="display: none"
                  accept="application/pdf"
                  @change="onPdfInput"
                />

                <div
                  v-if="identifierError"
                  class="text-caption text-error text-end px-4 pb-1"
                >
                  {{ identifierError }}
                </div>
                <!-- Desktop: unchanged horizontal actions -->
                <v-card-actions class="mt-3 d-none d-md-flex">
                  <v-btn
                    color="primary"
                    variant="tonal"
                    :disabled="!vehicle.details"
                    @click="openInventoryList"
                  >
                    {{ $t("vehicle_entry.inventory_list.label") }}
                    <v-icon end>mdi-format-list-bulleted</v-icon>
                  </v-btn>

                  <v-btn
                    color="primary"
                    variant="tonal"
                    @click="openPartsList({ component: 'main' })"
                  >
                    {{ $t("vehicle_entry.parts_list.label") }}
                    <v-icon end>mdi-format-list-bulleted-triangle</v-icon>
                  </v-btn>

                  <v-spacer />

                  <v-btn
                    color="grey-darken-4"
                    variant="outlined"
                    @click="stepper = 2"
                  >
                    <v-icon start> mdi-chevron-left </v-icon>
                    {{ $t("vehicle_entry.back") }}
                  </v-btn>

                  <v-btn
                    color="success"
                    :loading="loadingSave"
                    :disabled="!vehicle.details"
                    variant="outlined"
                    @click="save"
                  >
                    {{ $t("vehicle_entry.save") }}
                    <v-icon end> mdi-check-outline </v-icon>
                  </v-btn>
                </v-card-actions>

                <!-- Mobile: stacked full-width buttons -->
                <div class="d-flex d-md-none flex-column ga-2 mt-3 px-4 pb-3 step3-actions-mobile">
                  <v-btn
                    color="primary"
                    variant="tonal"
                    block
                    :disabled="!vehicle.details"
                    @click="openInventoryList"
                  >
                    {{ $t("vehicle_entry.inventory_list.label") }}
                    <v-icon end>mdi-format-list-bulleted</v-icon>
                  </v-btn>

                  <v-btn
                    color="primary"
                    variant="tonal"
                    block
                    @click="openPartsList({ component: 'main' })"
                  >
                    {{ $t("vehicle_entry.parts_list.label") }}
                    <v-icon end>mdi-format-list-bulleted-triangle</v-icon>
                  </v-btn>

                  <v-btn
                    color="grey-darken-4"
                    variant="outlined"
                    block
                    @click="stepper = 2"
                  >
                    <v-icon start> mdi-chevron-left </v-icon>
                    {{ $t("vehicle_entry.back") }}
                  </v-btn>

                  <v-btn
                    color="success"
                    block
                    :loading="loadingSave"
                    :disabled="!vehicle.details"
                    variant="outlined"
                    @click="save"
                  >
                    {{ $t("vehicle_entry.save") }}
                    <v-icon end> mdi-check-outline </v-icon>
                  </v-btn>
                </div>
              </v-stepper-window-item>
            </v-stepper-window>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="carExists">
      <v-card-title class="redColor d-flex text-white">
        <span class="headline"> </span>
        <v-spacer />
        <v-btn variant="outlined" icon color="white" @click="closeError()">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-card>
        <!--ALERT-->
        <v-alert
          :model-value="alert.value"
          :type="alert.type"
          variant="tonal"
          class="mt-2 ma-3"
        >
          {{ $t(alert.message) }}
        </v-alert>
      </v-card>
    </v-dialog>
    <!---- HIDDEN COMPONENTS ---->
    <parts-selection
      ref="partsSelection"
      @save="saveParts"
      @close="showAddVehicleDialog"
    />
    <inventory-list ref="inventoryList" @close="showAddVehicleDialog" />
    <photos
      ref="photos"
      @open-img-dialog="openImgDialog"
      @save="setPhotos"
      @close="showAddVehicleDialog"
    />
    <videos ref="videos" @save="setVideo" @close="showAddVehicleDialog" />
    <img-dialog ref="imgDialog" @close="showPhotos" />
    <!------------------------------------ VEHICLES INVENTORY ------------------------------------->
    <vehicle-filters
      v-show="mode === 0"
      ref="vehicleFilters"
      @search="(data) => setFilters('inventory', data)"
      @infocar-cad="openInfoCarCad"
    />

    <vehicles-inventory
      v-if="mode === 0"
      ref="vehiclesInventory"
      @images="openImgCarousel"
      @video="openVideoDialog"
      @qr="openQrDialog"
      @share="openShareDialog"
      @view-details="openDetailsDialog"
      @generate-qr="openQrGenerationDialog"
      @edit-vehicle="openEditVehicleDialog"
      @removed="getVehicles('all')"
      @infocar-cad="openInfoCarCad"
      @transfer="openTransferDialog"
    />
    <!------------------------------------- VEHICLES HISTORY -------------------------------------->
    <history-vehicle-filters
      v-show="mode === 1"
      ref="historyVehicleFilters"
      @search="(data) => setFilters('history', data)"
      @infocar-cad="openInfoCarCad"
    />

    <vehicles-history
      v-if="mode === 1"
      ref="vehiclesHistory"
      class="mt-0"
      @images="openImgCarousel"
      @video="openVideoDialog"
      @qr="openQrDialog"
      @share="openShareDialog"
      @view-details="openDetailsDialog"
      @generate-qr="openQrGenerationDialog"
      @returned="getVehicles('all')"
      @infocar-cad="openInfoCarCad"
    />

    <!--------------------------------------------------------------------------------------------->
    <!-- HIDDEN COMPONENTS -->
    <details-dialog
      ref="detailsDialog"
      @parts-list="openPartsList"
      @go-to-inventory="goToInventory"
    />
    <generate-qr-codes
      ref="generateQrCodes"
      @view-qr-codes="openPartsQrDialog"
    />
    <edit-vehicle
      ref="editVehicle"
      @close="getVehicles('inventory')"
      @parts-list="openPartsList"
    />

    <qr-dialog ref="qrDialog" />

    <parts-list ref="partsList" @close="closePartsList" @save="savePartsList" />

    <parts-qr-dialog ref="partsQrDialog" @close="showQrGenerationDialog" />

    <img-carousel ref="imgCarousel" />

    <video-dialog ref="videoDialog" />

    <qr-scanner
      ref="qrScanner"
      @details="openDetailsDialog"
      @generate-qr="openQrGenerationDialog"
      @edit="openEditVehicleDialog"
      @changed-location="getVehicles('all')"
    />

    <share-dialog ref="shareDialog" />
    <infocar-cad ref="infoCarCad" />
    <transfer-dialog ref="transferDialog" @close="getVehicles('all')" />
    <start-acceptance-dialog
      v-if="$store.getters.complianceEnabled"
      ref="startAcceptanceDialog"
    />
    <v-dialog v-model="populateModal" max-width="500">
      <v-card class="pa-3">
        <div class="ml-2 mb-2">Choose an institution to add vehicles.</div>
        <div>
          <v-autocomplete
            v-model="institution"
            :items="displayedInstitutions"
            :label="$t('parts.advanced_search.institution')"
            persistent-hint
            item-title="title"
            item-value="_id"
            solo
            color="red-darken-1"
            class="ml-2 mr-2 pt-2"
            clearable
          />
        </div>
        <div class="col-12 text-end d-flex ml-auto">
          <v-btn
            :disabled="!institution"
            color="red-darken-3"
            class="white--text"
            @click="populate"
          >
            populate
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import SelectVehicle from "@/components/VehicleEntry/selectVehicle.vue";
import VehicleDetails from "@/components/VehicleEntry/vehicleDetails.vue";
import VehicleView from "@/components/VehicleEntry/vehicleView.vue";
import InfocarGraficheAccordion from "@/components/VehicleEntry/infocarGraficheAccordion.vue";

import PartsSelection from "@/components/VehicleEntry/partsSelection.vue";
import InventoryList from "@/components/VehicleEntry/inventoryList.vue";
import PartsList from "@/components/VehicleEntry/partsList.vue";
import Photos from "@/components/VehicleEntry/photos.vue";
import Videos from "@/components/VehicleEntry/videos.vue";
import ImgDialog from "@/components/imgDialog.vue";

import VehiclesInventory from "@/components/VehicleEntry/vehiclesInventory.vue";
import VehiclesHistory from "@/components/VehicleEntry/vehiclesHistory.vue";

import VehicleFilters from "@/components/VehicleEntry/vehicleFilters.vue";
import HistoryVehicleFilters from "@/components/VehicleEntry/vehicleFilters.vue";

import DetailsDialog from "@/components/VehicleEntry/detailsDialog.vue";
import GenerateQrCodes from "@/components/VehicleEntry/generateQrCodes.vue";
import EditVehicle from "@/components/VehicleEntry/editVehicle.vue";

import PartsQrDialog from "@/components/VehicleEntry/partsQrDialog.vue";
import QrDialog from "@/components/qrDialogExtended.vue";
import ImgCarousel from "@/components/imgCarousel.vue";
import VideoDialog from "@/components/VehicleEntry/videoDialog.vue";
import QrScanner from "@/components/VehicleEntry/qrScanner.vue";
import ShareDialog from "@/components/VehicleEntry/shareDialog.vue";
import InfoCarCad from "@/components/infoCarCad.vue";
import TransferDialog from "@/components/VehicleEntry/transferDialog.vue";
import StartAcceptanceDialog from "@/components/Acceptance/startAcceptanceDialog.vue";

import postRequest from "../api/postRequest";
import getRequest from "../api/getRequest";
import { useDisplay } from "vuetify";

function dataURLtoBlob(dataUrl) {
  // convert base64 to raw binary data held in a string
  const byteString = atob(dataUrl.split(",")[1]);
  // separate out the mime component
  const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];
  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  // create a view into the buffer
  const ia = new Uint8Array(ab);
  // set the bytes of the buffer to the correct values
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  // write the ArrayBuffer to a blob, and you're done
  return new Blob([ab], { type: mimeString });
}

export default {
  components: {
    "select-vehicle": SelectVehicle,
    "vehicle-details": VehicleDetails,
    "vehicle-view": VehicleView,
    "infocar-grafiche-accordion": InfocarGraficheAccordion,
    "vehicles-inventory": VehiclesInventory,
    "parts-list": PartsList,
    "vehicles-history": VehiclesHistory,
    "vehicle-filters": VehicleFilters,
    "parts-selection": PartsSelection,
    "inventory-list": InventoryList,
    "details-dialog": DetailsDialog,
    "generate-qr-codes": GenerateQrCodes,
    "edit-vehicle": EditVehicle,
    photos: Photos,
    videos: Videos,
    "img-dialog": ImgDialog,
    "video-dialog": VideoDialog,
    "parts-qr-dialog": PartsQrDialog,
    "qr-dialog": QrDialog,
    "img-carousel": ImgCarousel,
    "qr-scanner": QrScanner,
    "share-dialog": ShareDialog,
    "infocar-cad": InfoCarCad,
    "transfer-dialog": TransferDialog,
    "start-acceptance-dialog": StartAcceptanceDialog,
    "history-vehicle-filters": HistoryVehicleFilters,
  },
  data: () => ({
    alert: { value: false, type: "error", message: "" },
    mode: 0,
    stepper: 1,
    /** Step 2: default Grafiche categories; second tab is vehicle CAD */
    step2ViewTab: "grafiche",
    addVehicleDialog: false,
    loadingSave: false,
    identifierError: "",
    vehicle: {
      details: null,
      info: null,
      parts: null,
      partsList: null,
      pdf: null,
      photos: [],
    },
    hiddenPartsListSource: null,
    allowedInstitutions: [
      "686540c3a99dd439285ff063",
      "687de0e83d1b82a6724f89b0",
      // add more IDs here
    ],
    populateModal: false,
    institution: "",
    displayedInstitutions: [],
    carExists: false,
    lastFilters: {
      inventory: null,
      history: null,
    },
  }),
  computed: {
    display() {
      return useDisplay();
    },
    videoWidth() {
      // Vuetify 3 breakpoints are reactive booleans
      if (this.$vuetify.display.xs) return 240;
      if (this.$vuetify.display.sm) return 480;
      if (this.$vuetify.display.md) return 680;
      // lg and xl fallback
      return 680;
    },
  },
  watch: {
    stepper(val, oldVal) {
      if (val === 2) this.step2ViewTab = "grafiche";
      if (oldVal === 2 && val !== 2)
        this.syncPartsByCategoryDraftFromGrafiche();
    },
    mode(newMode) {
      this.$nextTick(() => {
        if (newMode === 0 && this.lastFilters.inventory) {
          this.$refs.vehiclesInventory.setFilters(this.lastFilters.inventory);
        }

        if (newMode === 1 && this.lastFilters.history) {
          this.$refs.vehiclesHistory.setFilters(this.lastFilters.history);
        }
      });
    },
  },
  mounted() {
    // Force set filters.
    const { brand, model } = this.$route.query;
    if (brand && model) {
      const { vehicleFilters } = this.$refs;
      vehicleFilters.forceSetFilters(brand, model);
    }
  },
  created() {
    // "← Storico veicoli" on a removed car's acceptance opens the history tab (Stage 2 DF10).
    if (this.$route.query.tab === "history") this.mode = 1;
    this.getInstitutions();
  },

  methods: {
    selectVehicle(data) {
      const { selectVehicle } = this.$refs;
      selectVehicle.setVehicle(data);
    },
    setSelectedVehicle(details) {
      this.vehicle.details = details;
    },
    openAddVehicleDialog() {
      this.addVehicleDialog = true;
    },
    async closeAddVehicleDialog() {
      // Clear and reset everything BEFORE closing the dialog
      const { vehicleDetails, selectVehicle } = this.$refs;

      // Only attempt to clear if refs exist (dialog is open)
      if (vehicleDetails && typeof vehicleDetails.clear === "function") {
        vehicleDetails.clear();
      }
      if (selectVehicle && typeof selectVehicle.clear === "function") {
        selectVehicle.clear();
      }

      this.stepper = 1;
      this.step2ViewTab = "grafiche";
      this.identifierError = "";
      this.vehicle = {
        details: null,
        info: null,
        parts: null,
        photos: [],
      };
      this.targa = null;
      this.foundTarga = null;
      this.loadingSave = false;

      // Now close the dialog after resetting
      this.addVehicleDialog = false;
    },
    hideAddVehicleDialog() {
      this.addVehicleDialog = false;
    },
    showAddVehicleDialog() {
      this.addVehicleDialog = true;
    },
    openPartSelectionDialog(position) {
      const { partsSelection } = this.$refs;
      partsSelection.open(position, this.vehicle);
      // this.hideAddVehicleDialog();
    },
    openInventoryList() {
      const { inventoryList } = this.$refs;
      inventoryList.open(this.vehicle.details);
      // this.hideAddVehicleDialog();
    },
    openPartsList(data) {
      const { partsList } = this.$refs;
      if (data.component === "main") {
        partsList.open(data.vehicle, this.vehicle.partsList);
        // this.hideAddVehicleDialog();
      } else {
        partsList.open(
          data.vehicle,
          data.partsList,
          !!(data.component === "details"),
        );
        const { editVehicle, detailsDialog } = this.$refs;
        if (data.component === "edit") editVehicle.showDialog();
        if (data.component === "details") detailsDialog.showDialog();
      }
      this.hiddenPartsListSource = data.component;
    },
    closePartsList() {
      const { editVehicle, detailsDialog } = this.$refs;
      if (this.hiddenPartsListSource === "main") this.showAddVehicleDialog();
      if (this.hiddenPartsListSource === "edit") editVehicle.showDialog();
      if (this.hiddenPartsListSource === "details") detailsDialog.showDialog();
      this.hiddenPartsListSource = null;
    },
    savePartsList(partsList) {
      const { editVehicle } = this.$refs;
      if (!this.hiddenPartsListSource) this.vehicle.partsList = partsList;
      if (this.hiddenPartsListSource === "edit")
        editVehicle.vehicle.partsList = partsList;
    },
    saveParts(data) {
      if (!this.vehicle.parts) this.vehicle.parts = {};
      this.vehicle.parts[data.position] = data.items;
      this.vehicle.parts.comment = data.comment;
    },
    openPhotosDialog() {
      const { photos } = this.$refs;
      photos.open(this.vehicle.photos);
      // this.hideAddVehicleDialog();
    },
    openVideosDialog() {
      const { videos } = this.$refs;
      videos.open(this.vehicle.video);
      // this.hideAddVehicleDialog();
    },
    showPhotos() {
      const { photos } = this.$refs;
      photos.show();
    },
    openImgDialog(data) {
      const { photos, imgDialog } = this.$refs;
      imgDialog.open(data);
      photos.hide();
    },
    openImgCarousel(data) {
      const { imgCarousel } = this.$refs;
      imgCarousel.open({ type: "string", images: data });
    },
    openVideoDialog(data) {
      const { videoDialog } = this.$refs;
      videoDialog.open({ type: "string", data });
    },
    openQrDialog(data) {
      const { qrDialog } = this.$refs;
      qrDialog.open(data);
    },
    openDetailsDialog(vehicle) {
      const { detailsDialog } = this.$refs;
      detailsDialog.open(vehicle);
    },
    openQrGenerationDialog(data) {
      const { generateQrCodes } = this.$refs;
      generateQrCodes.open(data);
    },
    showQrGenerationDialog() {
      const { generateQrCodes } = this.$refs;
      generateQrCodes.show();
    },
    openPartsQrDialog(parts) {
      const { partsQrDialog, generateQrCodes } = this.$refs;
      generateQrCodes.hide();
      partsQrDialog.open(parts);
    },
    openEditVehicleDialog(vehicle) {
      const { editVehicle } = this.$refs;
      editVehicle.open(vehicle);
    },
    syncPartsByCategoryDraftFromGrafiche() {
      const acc = this.$refs.graficheAccordion;
      if (acc && typeof acc.getPartsByCategorySnapshot === "function") {
        this.vehicle.partsByCategory = acc.getPartsByCategorySnapshot();
      }
    },
    onIdentifierError(message) {
      this.identifierError = message || "";
    },
    continueFromDetails() {
      const { vehicleDetails } = this.$refs;
      if (!vehicleDetails?.hasRequiredIdentifiers()) {
        return;
      }
      this.identifierError = "";
      this.stepper = 2;
    },
    goStepThreeFromCategories() {
      this.syncPartsByCategoryDraftFromGrafiche();
      this.stepper = 3;
    },
    openShareDialog(data) {
      const { shareDialog } = this.$refs;
      shareDialog.open(data);
    },
    openTransferDialog(data) {
      const { transferDialog } = this.$refs;
      transferDialog.open(data);
    },
    async save() {
      let didPostCar = false;
      try {
        this.loadingSave = true;
        const acc = this.$refs.graficheAccordion;
        try {
          if (acc?.prepareSlotsForPersist) {
            await acc.prepareSlotsForPersist();
          }
        } catch {
          /* continue with partially loaded Grafiche */
        }
        this.syncPartsByCategoryDraftFromGrafiche();
        const { vehicleDetails, selectVehicle } = this.$refs;
        if (!vehicleDetails.hasRequiredIdentifiers()) {
          this.loadingSave = false;
          return;
        }
        this.identifierError = "";
        if (!vehicleDetails.validateVIN()) {
          this.loadingSave = false;
          return;
        }
        this.vehicle.info = vehicleDetails.getDetails();
        // Assign all the part groups by default.
        const partGroups = await getRequest("/part-groups/");
        if (!this.vehicle.parts) this.vehicle.parts = {};
        partGroups.forEach((group) => {
          if (!Object.keys(this.vehicle.parts).includes(group.position)) {
            this.vehicle.parts[group.position] = group.parts.map((part) => {
              const _part = part;
              _part.selected = true;
              return _part;
            });
          }
        });

        const formData = new FormData();
        formData.append(
          "data",
          JSON.stringify({
            institution_id: this.$store.getters.institutionId,
            brand: this.vehicle.details.brand,
            model: this.vehicle.details.model,
            version: this.vehicle.details.version,
            targa: this.vehicle.info.targa,
            vin: this.vehicle.info.vin,
            transmissionType: this.vehicle.info.transmissionType,
            transmissionLayout: this.vehicle.info.transmissionLayout,
            numberOfGears: this.vehicle.info.numberOfGears,
            externalColor: this.vehicle.info.externalColor,
            externalColorCode: this.vehicle.info.externalColorCode,
            internalColor: this.vehicle.info.internalColor,
            internalColorCode: this.vehicle.info.internalColorCode,
            interiorType: this.vehicle.info.interiorType,
            internalState: this.vehicle.info.internalState,
            vehicleCondition: this.vehicle.info.vehicleCondition,
            // frame: this.vehicle.info.frame,
            pra: this.vehicle.info.pra,
            km: this.vehicle.info.km,
            location: this.vehicle.info.location,
            notes: this.vehicle.info.notes,
            registrationYear: this.vehicle.info.registrationYear,
            withdrawnPIVA: this.vehicle.info.withdrawnPIVA,
            workingEngine: this.vehicle.info.workingEngine,
            parts: this.vehicle.parts,
            partsByCategory: this.vehicle.partsByCategory,
            partsList: this.vehicle.partsList,
            photos: this.vehicle.photos.map(
              (p) =>
                `${this.$store.getters.institutionId}-${this.vehicle.details.brand.brandCode}${this.vehicle.details.model.modelCode}${this.vehicle.details.version.versionCode}-${p.title}`,
            ),
            video: this.vehicle.video
              ? `${this.$store.getters.institutionId}-${this.vehicle.details.brand.brandCode}${this.vehicle.details.model.modelCode}${this.vehicle.details.version.versionCode}-${this.vehicle.video.title}`
              : null,
            document: this.vehicle.pdf
              ? `${this.$store.getters.institutionId}-${this.vehicle.details.brand.brandCode}${this.vehicle.details.model.modelCode}${this.vehicle.details.version.versionCode}-${this.vehicle.pdf.title}`
              : null,
          }),
        );
        this.vehicle.photos.forEach((p) =>
          formData.append(
            "car-photos",
            p.blob,
            `${this.$store.getters.institutionId}-${this.vehicle.details.brand.brandCode}${this.vehicle.details.model.modelCode}${this.vehicle.details.version.versionCode}-${p.title}`,
          ),
        );
        if (this.vehicle.pdf && this.vehicle.pdf.blob) {
          formData.append(
            "car-documents",
            this.vehicle.pdf.blob,
            `${this.$store.getters.institutionId}-${this.vehicle.details.brand.brandCode}${this.vehicle.details.model.modelCode}${this.vehicle.details.version.versionCode}-${this.vehicle.pdf.title}`,
          );
        }
        if (this.vehicle.video && this.vehicle.video.blob) {
          formData.append(
            "car-videos",
            this.vehicle.video.blob,
            `${this.$store.getters.institutionId}-${this.vehicle.details.brand.brandCode}${this.vehicle.details.model.modelCode}${this.vehicle.details.version.versionCode}-${this.vehicle.video.title}`,
          );
        }

        const res = await postRequest.formData("/car", "", formData);
        didPostCar = true;
        this.getVehicles("inventory");

        // Clear and reset BEFORE closing the dialog
        if (vehicleDetails && typeof vehicleDetails.clear === "function") {
          vehicleDetails.clear();
        }
        if (selectVehicle && typeof selectVehicle.clear === "function") {
          selectVehicle.clear();
        }

        // Close the dialog via the method (which now handles reset before close)
        this.closeAddVehicleDialog();

        // Dismantling & Compliance: offer to start the acceptance for the saved car.
        // Switch off or ineligible role: complianceEnabled is false and nothing happens.
        this.offerAcceptance(res && res.data);
      } catch (error) {
        this.getVehicles("inventory");
        // If the backend call succeeded but UI threw after, avoid "car exists" false positive.
        if (!didPostCar) {
          this.alert.value = true;
          this.alert.message = "vehicle_entry.car_exists";
          this.carExists = true;
        }
        // setTimeout(() => {
        //  this.alert.value = false;
        //  this.closeAddVehicleDialog();
        // }, 3000);
      } finally {
        this.loadingSave = false;
      }
    },
    closeError() {
      this.carExists = false;
      this.closeAddVehicleDialog();
    },
    // Only opens the dialog (no request here); starting and its errors live in the dialog,
    // so nothing can reach the save's catch block or its "car exists" alert.
    offerAcceptance(savedCar) {
      if (!this.$store.getters.complianceEnabled) return;
      if (!savedCar || !savedCar._id) return;
      const dialog = this.$refs.startAcceptanceDialog;
      if (dialog) dialog.open(savedCar);
    },
    getVehicles(type) {
      const { vehiclesInventory, vehiclesHistory } = this.$refs;
      if ((type === "all" || type === "inventory") && this.mode === 0)
        vehiclesInventory.getCars();
      if ((type === "all" || type === "history") && this.mode === 1)
        vehiclesHistory.getCars();
    },
    setFilters(type, data) {
      this.lastFilters[type] = data;
      const { vehiclesInventory, vehiclesHistory } = this.$refs;
      if ((type === "all" || type === "inventory") && this.mode === 0)
        vehiclesInventory.setFilters(data);
      if ((type === "all" || type === "history") && this.mode === 1)
        vehiclesHistory.setFilters(data);
    },
    setCars(cars) {
      this.cars = cars;
    },
    setPhotos(data) {
      this.vehicle.photos = data.photos;
    },
    setVideo(data) {
      this.vehicle.video = data.video;
    },
    openPdfInputComponent() {
      this.$refs.pdfInput.click();
    },
    onPdfInput(input) {
      const { files } = input.target;
      const fileReader = new FileReader();
      for (const file of files) {
        // eslint-disable-line no-restricted-syntax
        if (file) {
          fileReader.readAsDataURL(file);
        }
      }

      const random = Math.random().toString(36).substring(9);

      fileReader.addEventListener("load", () => {
        const dataUrl = fileReader.result;
        const blob = dataURLtoBlob(dataUrl);
        this.vehicle.pdf = {
          dataUrl,
          blob,
          title: `${random}${new Date().getTime().toString(16)}.pdf`,
        };
      });
    },
    viewPdf() {
      const objectUrl = window.URL.createObjectURL(this.vehicle.pdf.blob);
      window.open(objectUrl);
      window.URL.revokeObjectURL(objectUrl);
    },
    async scanQr() {
      await this.$nextTick();
      const qrScanner = this.$refs.qrScanner;
      if (qrScanner && typeof qrScanner.open === "function") {
        await this.$nextTick();
        qrScanner.open();
      }
    },
    openInfoCarCad(data) {
      const { infoCarCad } = this.$refs;
      infoCarCad.open(data);
    },
    goToInventory(data) {
      this.$router.push(
        `/inventory?titleCode=${data.code}&brand=${data.brand}&model=${data.model}&version=${data.version}`,
      );
    },
    openPopulate() {
      this.populateModal = true;
    },
    async populate() {
      this.loading = true;
      try {
        const response = await postRequest.object(
          `/demo/populate-cars?institution_id=${this.institution}`,
          null,
        );
        if (response) {
          this.populateModal = false;
          this.institution = "";
          this.getVehicles("inventory");
          this.loading = false;
        }
      } catch {
        this.populateModal = false;
        this.institution = "";
        this.loading = false;
      }
    },
    getInstitutions() {
      getRequest("/institution/")
        .then((response) => {
          if (response && response.institutions) {
            this.displayedInstitutions = response.institutions;
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.vehicle-entry-toolbar-strip {
  position: relative;
  z-index: 1;
  width: 100%;
}

.vehicle-entry-toolbar-root .min-width-0 {
  min-width: 0;
}

@media (min-width: 960px) {
  .vehicle-entry-toolbar-root .vehicle-entry-toolbar-actions {
    flex: 1 1 auto;
    min-width: 0;
    max-width: none;
  }

  .vehicle-entry-toolbar-root .vehicle-entry-toolbar-row {
    align-items: center;
  }

  .vehicle-entry-toolbar-root .vehicle-entry-toolbar-brand {
    max-width: min(38vw, 26rem);
  }
}

@media (max-width: 959.98px) {
  .add-vehicle-dialog-title {
    position: relative;
    padding: 12px 52px 12px 16px;
  }

  .add-vehicle-close-btn {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
  }

  .step3-actions-mobile {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
